/* ==========================================================================
 * NIKITA — Free Chain gift engine  (v4.1 — adds opt-in flight recorder)
 * --------------------------------------------------------------------------
 * Replaces the old gift script that lived ONLY in sections/main-cart.liquid
 * (it polled /cart.js, tested cart.total_price >= £10, and deleted the £0
 * chain from any cart that held nothing else).
 *
 * v4 behaviour — the chain STAYS in the cart:
 *   - Claiming the chain with an empty cart puts it in the cart and leaves it
 *     there. Nothing is removed and nothing reloads.
 *   - It can't be bought on its own: until the cart holds PAID items worth
 *     MIN_SPEND, checkout is locked (UpCart drawer AND the /cart page) and a
 *     message says how much is left to spend.
 *   - Runs site-wide, so it works inside the UpCart drawer. The old script only
 *     existed on /cart, and UpCart is set to redirectToCart:false.
 *   - Entitlement is stored as a CART ATTRIBUTE, so it dies with the order.
 *     One free chain per order, no cron, no cleanup.
 *   - Works with the Klaviyo buttons as they are today (/cart/add?id=<variant>)
 *     and with ?free_chain=gold|silver once they're repointed.
 *
 * The lock is a front-end guard, exactly as strong as the old script was. It
 * does not stop someone typing /checkout into the address bar or using an
 * express-pay button we don't control. Hard enforcement needs a Shopify
 * Function (Plus) or UpCart's native rewards.
 *
 * Install: loaded from snippets/cart-drawer.liquid via asset_url.
 * ========================================================================== */
(function () {
  'use strict';

  /* ---- Config ----------------------------------------------------------- */
  var GIFTS     = { gold: 55175691239800, silver: 55175691272568 };
  var MIN_SPEND = 1000;                // pence, PAID lines only (£10.00)
  var PARAM     = 'free_chain';        // ?free_chain=gold|silver
  var A_COLOUR  = '_free_chain';       // cart attribute: '' | 'gold' | 'silver'
  var A_STATE   = '_free_chain_state'; // cart attribute: '' | 'granted' | 'declined'
  var DEBUG     = false;

  /* true  = the chain stays in the cart while not yet eligible, checkout is
   *         locked until it is (the behaviour above).
   * false = old behaviour: the chain is only present once eligible; claiming
   *         with an empty cart parks it and sends the shopper to SHOP_URL. */
  var KEEP_GIFT_WHEN_NOT_ELIGIBLE = true;
  var LOCK_CHECKOUT        = true;     // only meaningful when KEEP is true
  var ADOPT_LEGACY_ADDS    = true;     // treat /cart/add?id=<gift> as a claim
  var OPEN_DRAWER_ON_CLAIM = true;     // show the shopper their chain in UpCart

  var SHOP_URL    = '/collections/all';    // KEEP=false only
  var NOTICE_KEY  = 'freeChainNotice';     // KEEP=false only
  var NOTICE_TEXT = 'Your free chain is reserved — spend £10 or more and it will be added automatically.';

  var GIFT_IDS = Object.keys(GIFTS).map(function (k) { return GIFTS[k]; });
  var busy = false, queued = false, lastSig = null, justClaimed = false;
  var lock = { locked: false, msg: '', short: '' };
  var paintTimer = null;

  function log() {
    if (DEBUG) console.log.apply(console, ['[free-chain]'].concat([].slice.call(arguments)));
  }

  /* ---- Flight recorder (opt-in) -----------------------------------------
   * Visit any page with ?fcdebug=1 to switch it on (stored in localStorage),
   * ?fcdebug=0 to switch it off and clear it. While on, it records — across
   * page reloads — which theme loaded, every request that touches the cart
   * and which file made it, and how each page was reached (navigate/reload).
   * A "FC debug" button appears bottom-left; click it for a copyable report. */
  var LOG_KEY = 'fcLog';
  var debugOn = false;

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function themeId() { return (window.Shopify && Shopify.theme && Shopify.theme.id) || null; }

  function rec(type, data) {
    if (!debugOn) return;
    try {
      var a = JSON.parse(lsGet(LOG_KEY) || '[]');
      var row = { t: new Date().toISOString().slice(11, 23), path: location.pathname, e: type };
      for (var k in (data || {})) row[k] = data[k];
      a.push(row);
      lsSet(LOG_KEY, JSON.stringify(a.slice(-120)));
    } catch (e) {}
  }

  function stackTop() {
    return (new Error().stack || '').split('\n').slice(2, 11)
      .filter(function (s) { return !/upcart-bundle|free-chain-gift/.test(s) || /free-chain-gift/.test(s); })
      .map(function (s) { return s.trim().replace(/https?:\/\/[^\s)]*\//g, '').slice(0, 90); }).slice(0, 4).join(' | ');
  }

  function installTracers() {
    var re = /\/cart\/(add|change|update|clear)/;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : ((input && input.url) || '');
        if (re.test(url)) rec('fetch', { url: url.slice(0, 50), m: (init && init.method) || 'GET',
          body: init && typeof init.body === 'string' ? init.body.slice(0, 140) : null, from: stackTop() });
      } catch (e) {}
      return nativeFetch.apply(this, arguments);
    };
    var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__fc = { m: m, u: String(u) }; return xo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (b) {
      try {
        if (this.__fc && re.test(this.__fc.u)) rec('xhr', { url: this.__fc.u.slice(0, 50), m: this.__fc.m,
          body: typeof b === 'string' ? b.slice(0, 140) : null, from: stackTop() });
      } catch (e) {}
      return xs.apply(this, arguments);
    };
  }

  function debugReportUi() {
    var raw = lsGet(LOG_KEY) || '[]', pretty = raw;
    try { pretty = JSON.parse(raw).map(function (r) { return JSON.stringify(r); }).join('\n'); } catch (e) {}
    var wrap = document.createElement('div');
    wrap.style.cssText = 'position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;padding:16px';
    var box = document.createElement('div');
    box.style.cssText = 'background:#fff;color:#151515;width:min(900px,100%);max-height:90vh;display:flex;flex-direction:column;gap:8px;padding:14px;border-radius:8px;font:13px/1.4 system-ui,sans-serif';
    var ta = document.createElement('textarea');
    ta.readOnly = true; ta.value = pretty;
    ta.style.cssText = 'width:100%;height:55vh;font:11px/1.4 ui-monospace,monospace';
    var row = document.createElement('div'); row.style.cssText = 'display:flex;gap:8px';
    function btn(label, fn) { var b = document.createElement('button'); b.textContent = label; b.style.cssText = 'padding:8px 14px;border:1px solid #151515;background:#fff;cursor:pointer'; b.addEventListener('click', fn); row.appendChild(b); }
    btn('Copy', function () { ta.select(); try { document.execCommand('copy'); } catch (e) {} });
    btn('Clear log', function () { lsSet(LOG_KEY, '[]'); ta.value = ''; });
    btn('Close', function () { wrap.remove(); });
    box.appendChild(document.createTextNode('Free chain flight recorder — click Copy and send me the text.'));
    box.appendChild(ta); box.appendChild(row); wrap.appendChild(box); document.body.appendChild(wrap);
  }

  function debugBadge() {
    var b = document.createElement('button');
    b.textContent = 'FC debug · theme ' + themeId();
    b.style.cssText = 'position:fixed;left:10px;bottom:64px;z-index:2147483000;background:#E083D4;color:#151515;border:0;border-radius:14px;padding:6px 12px;font:12px system-ui,sans-serif;cursor:pointer';
    b.addEventListener('click', debugReportUi);
    document.body.appendChild(b);
  }

  function debugInit() {
    var p = new URLSearchParams(location.search), flag = p.get('fcdebug');
    if (flag === '1') lsSet('fcDebug', '1');
    if (flag === '0') { lsSet('fcDebug', '0'); lsSet(LOG_KEY, '[]'); }
    if (flag !== null) {
      p.delete('fcdebug');
      var qs = p.toString();
      try { history.replaceState({}, '', location.pathname + (qs ? '?' + qs : '') + location.hash); } catch (e) {}
    }
    debugOn = lsGet('fcDebug') === '1';
    if (!debugOn) return;
    installTracers();
    var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    rec('load', { theme: themeId(), script: 'v4.1', navType: nav.type || null,
                  ref: (document.referrer || '').replace(/^https?:\/\/[^/]+/, '').slice(0, 60) || null,
                  upcart: typeof window.upcartRefreshCart });
    window.addEventListener('pagehide', function () { rec('pagehide', {}); });
    if (document.body) debugBadge(); else document.addEventListener('DOMContentLoaded', debugBadge);
  }

  /* ---- Small helpers ---------------------------------------------------- */
  function isCartPage() { return /\/cart\/?$/.test(location.pathname); }
  function isGiftId(id) { return GIFT_IDS.indexOf(id) !== -1; }
  function isGiftLine(i) { return isGiftId(i.variant_id); }
  function giftLines(cart) { return cart.items.filter(isGiftLine); }
  function colourOf(id) {
    for (var k in GIFTS) { if (GIFTS[k] === id) return k; }
    return null;
  }

  function fmt(pence, currency) {
    var whole = pence % 100 === 0;
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency', currency: currency || 'GBP',
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
      }).format(pence / 100);
    } catch (e) {
      return '£' + (pence / 100).toFixed(whole ? 0 : 2);
    }
  }

  function paidTotal(cart) {
    return cart.items.reduce(function (sum, i) {
      if (isGiftLine(i)) return sum;                       // never count the gift
      var line = (i.final_line_price != null) ? i.final_line_price : i.line_price;
      return sum + (line || 0);
    }, 0);
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* /cart/update.js can add a line AND write attributes in one atomic call, and
     returns the resulting cart. */
  function writeCart(payload) {
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function repaint() {
    // The theme's own /cart page is server-rendered, so it needs a reload.
    if (isCartPage()) { location.reload(); return Promise.resolve(); }
    if (typeof window.upcartRefreshCart === 'function') {
      try { return Promise.resolve(window.upcartRefreshCart()); }
      catch (e) { log('upcartRefreshCart threw', e); }
    }
    return Promise.resolve();
  }

  /* ---- Notice bar ------------------------------------------------------- */
  function showNotice(text) {
    var old = document.querySelector('.free-chain-notice');
    if (old) old.remove();
    var bar = document.createElement('div');
    bar.className = 'free-chain-notice';
    bar.setAttribute('role', 'status');
    bar.style.cssText = [
      'position:fixed', 'left:0', 'right:0', 'top:0', 'z-index:2147483000',
      'background:#151515', 'color:#fff', 'padding:14px 44px 14px 20px',
      'font-size:14px', 'line-height:1.4', 'text-align:center',
      'font-family:inherit', 'box-shadow:0 2px 14px rgba(0,0,0,.18)'
    ].join(';');
    bar.appendChild(document.createTextNode(text));

    var close = document.createElement('button');
    close.setAttribute('aria-label', 'Dismiss');
    close.textContent = '×';
    close.style.cssText = [
      'position:absolute', 'right:12px', 'top:50%', 'transform:translateY(-50%)',
      'background:none', 'border:0', 'color:#fff', 'font-size:22px',
      'line-height:1', 'cursor:pointer', 'padding:4px 8px'
    ].join(';');
    close.addEventListener('click', function () { bar.remove(); });
    bar.appendChild(close);

    document.body.appendChild(bar);
    setTimeout(function () { if (bar.parentNode) bar.remove(); }, 7000);
  }

  /* KEEP=false only: carry a notice across the redirect to SHOP_URL. */
  function sendShopping() {
    try { sessionStorage.setItem(NOTICE_KEY, '1'); } catch (e) {}
    if (isCartPage()) location.replace(SHOP_URL); else showNotice(NOTICE_TEXT);
    return Promise.resolve();
  }
  function showNoticeIfPending() {
    var pending;
    try { pending = sessionStorage.getItem(NOTICE_KEY); } catch (e) { return; }
    if (!pending) return;
    try { sessionStorage.removeItem(NOTICE_KEY); } catch (e) {}
    showNotice(NOTICE_TEXT);
  }

  /* ---- Checkout lock: state ---------------------------------------------- */
  function computeLock(cart) {
    var giftIn = cart.items.some(isGiftLine);
    var spend  = paidTotal(cart);
    var cur    = cart.currency;
    var wasLocked = lock.locked;
    lock.locked = !!(LOCK_CHECKOUT && KEEP_GIFT_WHEN_NOT_ELIGIBLE && giftIn && spend < MIN_SPEND);
    if (wasLocked !== lock.locked) rec('lock', { locked: lock.locked, giftIn: giftIn, paidPence: spend });
    lock.short  = spend > 0
      ? 'Add ' + fmt(MIN_SPEND - spend, cur) + ' more to unlock it'
      : 'Spend ' + fmt(MIN_SPEND, cur) + ' or more to unlock it';
    lock.msg = 'Your free chain is waiting. ' + lock.short + '.';
  }

  /* ---- Checkout lock: rendering ------------------------------------------ */
  var DOC_CSS =
    'html[data-fc-locked] button[name="checkout"],html[data-fc-locked] input[name="checkout"]{opacity:.4;cursor:not-allowed}' +
    'html[data-fc-locked] .custom-additional,html[data-fc-locked] .additional-checkout-buttons,' +
    'html[data-fc-locked] .shopify-payment-button{display:none!important}' +
    '.fc-locked-msg{font-weight:600}';

  var SHADOW_CSS =
    ':host([data-fc-locked]) .upcart-checkout-button-container{opacity:.45;cursor:not-allowed}' +
    '.fc-msg{margin:0 0 10px;padding:10px 12px;border:1px solid #E083D4;border-radius:6px;' +
    'background:#fff;color:#151515;font-size:13px;line-height:1.4;text-align:center}';

  function injectDocCss() {
    if (document.getElementById('fc-style')) return;
    var st = document.createElement('style');
    st.id = 'fc-style';
    st.textContent = DOC_CSS;
    document.head.appendChild(st);
  }

  function upcartRoot() {
    var h = document.getElementById('upCart');
    return (h && h.shadowRoot) ? h.shadowRoot : null;
  }

  /* Intercepts clicks on any checkout control while locked. Registered once on
     the document (theme /cart page) and once inside UpCart's shadow root. */
  function onClickCapture(e) {
    if (!lock.locked) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var hit = t.closest(
      '.upcart-checkout-button-container, a[href*="/cart/c/"], a[href*="/checkout"],' +
      'button[name="checkout"], input[name="checkout"]'
    );
    if (!hit) return;
    e.preventDefault();
    e.stopPropagation();
    showNotice(lock.msg);
  }

  function paintShadow() {
    var sr = upcartRoot();
    if (!sr) return;
    if (!sr.querySelector('#fc-style')) {
      var st = document.createElement('style');
      st.id = 'fc-style';
      st.textContent = SHADOW_CSS;
      sr.appendChild(st);
    }
    if (!sr.__fcClick) { sr.__fcClick = true; sr.addEventListener('click', onClickCapture, true); }
    if (!sr.__fcObs) {
      // UpCart re-renders its footer on every cart change; put the message back.
      sr.__fcObs = new MutationObserver(schedulePaint);
      sr.__fcObs.observe(sr, { childList: true, subtree: true });
    }
    var host = sr.host;
    if (lock.locked) host.setAttribute('data-fc-locked', '1'); else host.removeAttribute('data-fc-locked');

    var cont = sr.querySelector('.upcart-checkout-button-container');
    var m = sr.querySelector('.fc-msg');
    if (lock.locked && cont && cont.parentNode) {
      if (!m) { m = document.createElement('div'); m.className = 'fc-msg'; m.setAttribute('role', 'status'); }
      if (m.textContent !== lock.msg) m.textContent = lock.msg;
      if (cont.previousSibling !== m) cont.parentNode.insertBefore(m, cont);
    } else if (m && m.parentNode) {
      m.parentNode.removeChild(m);
    }
  }

  function paintTheme() {
    var root = document.documentElement;
    if (lock.locked) root.setAttribute('data-fc-locked', '1'); else root.removeAttribute('data-fc-locked');
    var boxes = document.querySelectorAll('.custom-cart-free-product-error');
    for (var i = 0; i < boxes.length; i++) {
      var p = boxes[i].querySelector('.fc-locked-msg');
      if (lock.locked) {
        if (!p) { p = document.createElement('p'); p.className = 'fc-locked-msg'; boxes[i].appendChild(p); }
        if (p.textContent !== lock.msg) p.textContent = lock.msg;
      } else if (p) {
        p.remove();
      }
    }
  }

  function paintLock() { paintTheme(); paintShadow(); }
  function schedulePaint() {
    clearTimeout(paintTimer);
    paintTimer = setTimeout(paintLock, 40);
  }

  /* ---- Settling after a pass -------------------------------------------- */
  function afterClaim(cart) {
    if (!justClaimed) return;
    justClaimed = false;
    if (!cart.items.some(isGiftLine)) return;
    if (!isCartPage() && OPEN_DRAWER_ON_CLAIM && typeof window.upcartOpenCart === 'function') {
      try { window.upcartOpenCart(); schedulePaint(); return; } catch (e) { log('upcartOpenCart threw', e); }
    }
    showNotice('Your free chain is in your bag.' + (lock.locked ? ' ' + lock.short + '.' : ''));
  }

  function settle(cart) {
    if (!cart || !cart.items) return;       // e.g. a 422 error body
    computeLock(cart);
    paintLock();
    afterClaim(cart);
  }

  function commit(payload, linesChanged) {
    return writeCart(payload).then(function (c) {
      var p = linesChanged ? repaint() : Promise.resolve();
      return p.then(function () { settle(c); });
    });
  }

  /* ---- 1. Capture the entitlement handed over by the Klaviyo popup ------ */
  function captureEntitlement() {
    var params = new URLSearchParams(location.search);
    var colour = String(params.get(PARAM) || '').toLowerCase();
    if (!GIFTS[colour]) return Promise.resolve(false);

    params.delete(PARAM);                    // so a refresh / shared link can't re-trigger
    var qs = params.toString();
    try { history.replaceState({}, '', location.pathname + (qs ? '?' + qs : '') + location.hash); } catch (e) {}

    var attrs = {};
    attrs[A_COLOUR] = colour;
    attrs[A_STATE]  = '';                    // fresh entitlement, not yet in the cart
    justClaimed = true;
    log('entitlement captured:', colour);
    return writeCart({ attributes: attrs }).then(function () { return true; });
  }

  /* ---- 2. Reconcile the cart against the entitlement -------------------- */
  function reconcile(cart) {
    var attrs  = cart.attributes || {};
    var colour = String(attrs[A_COLOUR] || '').toLowerCase();
    var state  = String(attrs[A_STATE] || '');
    var giftId = GIFTS[colour] || null;
    var gifts  = giftLines(cart);
    var spend  = paidTotal(cart);
    var earned = spend >= MIN_SPEND;
    var allowed = KEEP_GIFT_WHEN_NOT_ELIGIBLE || earned;

    // Skip if nothing material changed. Stops add -> cartUpdated -> sync -> add loops.
    var sig = [colour, state, earned, cart.item_count, gifts.map(function (g) {
      return g.variant_id + ':' + g.quantity;
    }).join(',')].join('|');
    if (sig === lastSig) { settle(cart); return Promise.resolve(); }
    lastSig = sig;
    log('colour=' + colour, 'state=' + state, 'earned=' + earned, 'paid=' + spend, 'gifts=' + gifts.length);
    rec('reconcile', { colour: colour, state: state, earned: earned, paidPence: spend, gifts: gifts.length, lines: cart.items.length });

    /* (1) A gift is in the cart but no entitlement was ever recorded — which is
           what the Klaviyo GOLD button does today via /cart/add?id=<variant>.
           Adopt it as a claim and run the normal logic on the result. */
    if (!giftId) {
      if (!gifts.length) { settle(cart); return Promise.resolve(); }
      var adopted = ADOPT_LEGACY_ADDS ? colourOf(gifts[0].variant_id) : null;
      if (adopted) {
        justClaimed = true;
        var a = {}; a[A_COLOUR] = adopted; a[A_STATE] = '';
        log('adopting legacy add:', adopted);
        return writeCart({ attributes: a }).then(function (c) { lastSig = null; return reconcile(c); });
      }
      var rm = {}; gifts.forEach(function (g) { rm[g.variant_id] = 0; });
      return commit({ updates: rm }, true);
    }

    /* (2) Entitlement held. */
    var updates = {}, attrOut = {}, dirty = false;
    var mine  = gifts.filter(function (g) { return g.variant_id === giftId; });
    var wrong = gifts.filter(function (g) { return g.variant_id !== giftId; });
    var present = mine.length > 0;

    if (!allowed) {
      // KEEP=false only: not yet eligible, so the chain must not be in the cart.
      gifts.forEach(function (g) { updates[g.variant_id] = 0; dirty = true; });
      if (gifts.length && state !== 'declined') attrOut[A_STATE] = '';
    } else {
      wrong.forEach(function (g) { updates[g.variant_id] = 0; dirty = true; });   // wrong colour
      if (present && mine[0].quantity > 1) { updates[giftId] = 1; dirty = true; } // one per order

      if (state === 'granted' && !present && !wrong.length) {
        // The shopper deleted it themselves. Respect that — never re-add.
        attrOut[A_STATE] = 'declined';
        log('shopper removed the gift — standing down');
      } else if (state !== 'declined' && !present) {
        updates[giftId] = 1; dirty = true;                   // grant (or swap colour)
        attrOut[A_STATE] = 'granted';
        if (state === '') justClaimed = true;
        log('granting', colour);
      } else if (state === '' && present) {
        attrOut[A_STATE] = 'granted';
      }
    }

    var hasAttr = Object.keys(attrOut).length > 0;
    if (!dirty && !hasAttr) { settle(cart); return Promise.resolve(); }

    var payload = {};
    if (dirty)   payload.updates = updates;
    if (hasAttr) payload.attributes = attrOut;
    var emptiesCart = dirty && !allowed && cart.items.every(isGiftLine);
    return commit(payload, dirty).then(function () {
      if (emptiesCart) return sendShopping();                // KEEP=false only
    });
  }

  function sync() {
    if (busy) { queued = true; return Promise.resolve(); }
    busy = true;
    return getCart()
      .then(reconcile)
      .catch(function (e) { console.warn('[free-chain] sync failed', e); })
      .then(function () {
        busy = false;
        if (queued) { queued = false; return sync(); }
      });
  }

  /* ---- 3. Wire up ------------------------------------------------------- */
  function bindUpcart() {
    var tries = 0;
    (function poll() {
      if (typeof window.upcartSubscribeCartUpdated === 'function') {
        ['upcartSubscribeAddedToCart', 'upcartSubscribeCartUpdated',
         'upcartSubscribeCartLoaded', 'upcartSubscribeCartOpened'].forEach(function (fn) {
          if (typeof window[fn] === 'function') {
            try { window[fn](function () { sync(); schedulePaint(); }); }
            catch (e) { log(fn + ' bind failed', e); }
          }
        });
        log('bound to UpCart');
        return;
      }
      if (++tries > 50) { log('UpCart never appeared — running on theme events only'); return; }
      setTimeout(poll, 200);
    })();
  }

  function hookShadowWhenReady() {
    var tries = 0;
    (function poll() {
      if (upcartRoot()) { paintLock(); return; }
      if (++tries > 40) return;
      setTimeout(poll, 500);
    })();
  }

  function boot() {
    debugInit();
    injectDocCss();
    document.addEventListener('click', onClickCapture, true);
    showNoticeIfPending();
    captureEntitlement().then(sync);
    bindUpcart();
    hookShadowWhenReady();

    // Theme-side fallbacks (product pages, the /cart page, back-button restores).
    document.addEventListener('cart:updated', function () { sync(); });
    document.addEventListener('cart:refresh', function () { sync(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) sync(); });

    window.freeChainSync = sync;             // handy for support / testing
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
